import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ClientService } from '../services/client.service';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatDialog } from '@angular/material';
import { AddClientModalComponent } from './add-client-modal/add-client-modal.component';
import { EditClientModalComponent } from './edit-client-modal/edit-client-modal.component';
import { FilterService } from "../services/filter.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilityService } from './../services/utility.service';
import { DeleteConfirmModalComponent } from '../commons/delete-confirm-modal/delete-confirm-modal.component';
import { preferencesLists } from '../_models/staticArray'

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})

export class ClientsComponent implements OnInit {
  loading: Boolean;
  clients: any = [];
  clientsCopy: any = [];
  tempClients: any = [];
  length;
  pageSizeOptions: number[] = [25, 50, 100];
  displayedColumns = [];
  displayedColumn1: string[] = ['name', 'email', 'actions']
  displayedColumn2: string[] = ['name', 'email', 'address', 'terms', 'actions'];
  userPreferenceList = []
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  noDataMsg1 = {
    title: "No Users!",
    data: "You have not yet added any users"
  }
  noDataMsg2 = {
    title: "No Clients!",
    data: "You have not yet added any clients"
  }
  noDataMsg
  activeClient;
  mainHeader: String
  // sort: MatSort;

  afterFilter: any;
  filterActive: Boolean = false;
  isUserList: Boolean = false
  clientId: any;
  sort: MatSort;
  singleClientDetails: any = {}
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  // @ViewChild(MatSort, { static: true }) sort: MatSort;
  // @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
  //   this.paginator = mp;
  //   this.setDataSourceAttributes();
  // }
  // setDataSourceAttributes() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }


  constructor(
    public _clientService: ClientService,
    public dialog: MatDialog,
    public _filter: FilterService,
    public _snackBar: MatSnackBar,
    public _utilityService: UtilityService,
    private activatedRoute: ActivatedRoute,
    public _route: Router,
    public _cd: ChangeDetectorRef
  ) {
    this.clients = [];
    console.log('this.clients', this.clients);
    this.dataSource = new MatTableDataSource<any>(this.clients);
    this.activatedRoute.queryParams.subscribe(qparams => {
      console.log("What is the params value ", qparams);
      if (qparams && qparams.users) this.isUserList = true, this.getClientUserList(qparams.users), this.clientId = qparams.users, this.displayedColumns = this.displayedColumn1, this.noDataMsg = this.noDataMsg1
      else this.getClients(), this.noDataMsg = this.noDataMsg2, this.isUserList = false
    })
  }

  ngOnInit() {

    if (this.isUserList) this.mainHeader = 'Users'
    else this.mainHeader = 'Clients'

    // this.loading = true;
    // this.getClients();
    // if (this.isUserList) {
    //   this.getClientUserList(this.clientId)
    //   const paginatorIntl = this.paginator._intl;
    //   paginatorIntl.nextPageLabel = '';
    //   paginatorIntl.previousPageLabel = '';
    // }
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  filter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.filterActive = false;
      this.clients = this.clientsCopy
      this.updateData(this.clients)
    }
    this.clients = this.clientsCopy
    let filteredClients = this._filter.filter(searchText, this.clients, ['name', 'email'], 'newfilter');
    this.clients = filteredClients
    this.updateData(filteredClients)
    if (filteredClients.length <= 0) {
      // this.afterFilter = "No clients with matched search text found!"
      let afterFilter1 = {
        title: "No Users!",
        data: "Sorry, no users matched your search"
      }
      let afterFilter2 = {
        title: "No Clients!",
        data: "Sorry, no clients matched your search"
      }
      this.afterFilter = this.isUserList ? afterFilter1 : afterFilter2
    }
  }

  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }


  // UTILITY

  updateData(clients) {
    console.log("UPDATING DATA = ", clients, this.isUserList)
    this.dataSource = new MatTableDataSource(clients);
    // if (!this.isUserList) this.clients = clients;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'name': return item.name;
        case 'email': return item.email;
        // case 'address': return item && item.physicalAddress ? item.physicalAddress.address : null;
        // case 'terms': return item.paymentTerms;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    this._cd.detectChanges()
    console.log("SETTING SORT TO = ", this.dataSource.sort, this.dataSource)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
  }



  // MODALS
  addClientModal() {
    console.log("This is client new user open model");

    let obj = {
      isClient: this.isUserList ? false : true,
    }
    if (this.isUserList) obj['masterClientId'] = this.singleClientDetails._id
    this._utilityService.commonDialogBoxOpen(AddClientModalComponent, obj)
      .afterClosed().subscribe((users) => {
        console.log("Client added in controller = ", users);
        if (users == undefined) return;
        this.clients.push(users);
        if (this.isUserList) this._utilityService.handleSnackBar({ msg: "User added successfully!", button: "OK" }), this.updateData(this.clients);
        else this._utilityService.handleSnackBar({ msg: "Client added successfully!", button: "OK" }), this._route.navigate(['/client/edit/' + users._id])
      }, err => {
        return this.handleSnackBar({ msg: "Client could not be added!", button: "Ok" });
      });
  }


  editClientModal(data) {
    this.activeClient = data;
    // data['isClient'] = false
    data['isEdit'] = true
    // data['masterClientId'] = this.clientId
    console.log('Edit Modal Here===>', data);
    this._utilityService.commonDialogBoxOpen(AddClientModalComponent, data)
      .afterClosed().subscribe((data) => {
        if (!data) return
        if (data.result == "err") return this._utilityService.handleSnackBar({ msg: "User could not be edited!", button: "Ok" });
        if (data.action == 'edit') {
          this.loading = true;
          console.log("HANDLING EDIT SUCCESS", data);
          data = data;
          let index = this.clients.findIndex(function (i) {
            return i._id === data._id;
          })
          this.clients[index] = data.data;
          this._utilityService.handleSnackBar({ msg: "User edited successfully!", button: "OK" })
          if (this.isUserList) this.getClientUserList(this.clientId)
          else this.getClients()
          this.loading = false;
        }
      })
  }


  deleteUserModel(data) {
    console.warn("DELETING ", data._id);
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, "user")
      .afterClosed().subscribe((confirm) => {
        if (confirm == '') return
        else if (confirm == 'yes') {
          this.loading = true;
          this._clientService.deleteClient(data._id, false).subscribe(clients => {
            console.log("clients ====> ", clients)
            this._utilityService.handleSnackBar({ msg: "User deleted successfully!", button: "OK" })
            if (this.isUserList) this.getClientUserList(this.clientId)
            else this.getClients()
            this.loading = false
          }, err => {
            this.loading = false;
          });
        }
      })
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  // API CALLS

  getClients() {
    this.loading = true;
    this._clientService.getClients().subscribe((clients) => {
      console.log("Here is the client user list", clients);

      this.clients = clients;
      this.clientsCopy = clients;
      // this.tempClients = clients;
      this.loading = false;
      let userPreferences = JSON.parse(localStorage.getItem('preferences'));
      let pagePreference = userPreferences.find((x) => x.currentUrl === this._route.url)
      let dynamicTable = []
      let latest = preferencesLists.map((x) => {
        if (pagePreference.table.includes(x.key)) x.value = true, dynamicTable.push(x.key)
        else x.value = false
        return x
      })
      this.displayedColumns = dynamicTable;
      this.userPreferenceList = latest
      console.log("WHAT IS THE USER", this.userPreferenceList)
      // this.updateData(clients)
    }, err => {
      this.handleSnackBar({ msg: err.msg, button: "Ok" });
    });
  }


  getClientUserList(clientId) {
    this.loading = true;
    this._clientService.getClientUserList(clientId).subscribe(data => {
      console.log("Single client user data", data);
      this.singleClientDetails = data[0]
      this.clients = data[0].clientUsers;
      this.clientsCopy = this.clients;
      this.updateData(data[0].clientUsers)
      this.loading = false;
    }, err => {
      this.handleSnackBar({ msg: err.msg, button: "Ok" });
    })
  }

}
